import { createSlice } from "@reduxjs/toolkit";
import { initialState } from ".";
import {
  addInvoiceGenerationAction,
  addOtherInvoiceGenerationAction,
  approveInvoiceAction,
  assignInvoiceColumnsToClientAction,
  checkDuplicateEntryAction,
  copyInvoiceGenerationAction,
  deleteInvoiceAction,
  deleteOtherInvoiceAction,
  getAllExpensesInvoicesListAction,
  getAllInvoiceColumnsListAction,
  getAllMappedClientColumnListAction,
  getAllOtherInvoicesListAction,
  getAllRevenuInvoicesListAction,
  getInvoiceAllComment,
  getPaymentPendingList,
  getSingleInvoiceDetailsAction,
  getSingleOtherInvoiceDetailsAction,
  invoiceGenerationBulkUploadAction,
  postInvoiceAllComment,
  updateInvoiceGenerationAction,
  updateOtherInvoiceGenerationAction,
  getAllAllocationListAction,
  postLockingEntryAction,
  invoiceNotesListAction,
  getEinvoiceDataAction,
  getReviewEinvoiceDataAction,
  postEinvoiceDataAction,
  postCancelEinvoiceDataAction,
  sendOverdueEmailApiAction,
  invoiceGenerationRevenuesBulkUploadAction,
  invoiceGenerationExpensesBulkUploadAction,
  getInvoiceCustomerInvoiceDownload,
  getBomDataAction,
  postBomDataAction,
  updateBomDataAction,
  getSingleBomDataAction,
  getBOMSavedTemplateListAction,
  getSingleBomTemplateDataAction,
  uniqueCheckBOMSavedTemplateNameAction,
  getInvoiceHistoryDataAction,
  getBulkUploadHistoryAction,
  getOthersInvoiceHistoryDataAction,
  invoiceGenerationSuspenseBulkUploadAction,
  getReviewEWayBillDataAction,
  getGenerateEWayBillAction,
  cancelEWayBillDataAction,
  postExtendEWayBillAction,
  checkDistanceCountAction,
  postEinvoiceAuthenticationAction,
  postEwayBillAuthenticationAction,
  postLockingEntryBOMAction,
  postInvoiceOcrAction,
  updateVehicleEWayBillDetails,
  updateTransporterEWayBillDetails,
  getClientColumnAssignedListAction,
  getGstrTwoATwoBComparePayloadAction,
} from "./actions";
import { invoiceGenerationReducer } from ".";
import { InvoiceGenerationTypes } from "./invoiceGenrationTypes";

export const invoiceGenerationSlice = createSlice({
  name: "invoiceGeneration",
  initialState,
  reducers: invoiceGenerationReducer,
  extraReducers: {
    [getAllInvoiceColumnsListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllInvoiceColumnsListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result = {}, message, status_code, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        allColumnsList: result,
      };
    },
    [getAllInvoiceColumnsListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      success: 0,
      fetching: false,
    }),
    [getAllMappedClientColumnListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllMappedClientColumnListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result = [], message, status_code, success } = payload;
      const { expenses, revenues, others } = result;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        mappedExpensesColumnsList: expenses,
        mappedRevenueColumnsList: revenues,
        mappedOthersColumnList: others,
        message,
      };
    },
    [getAllMappedClientColumnListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      success: 0,
      fetching: false,
    }),
    [assignInvoiceColumnsToClientAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [assignInvoiceColumnsToClientAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result = {}, message, status_code, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [assignInvoiceColumnsToClientAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addInvoiceGenerationAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [addInvoiceGenerationAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result = {}, message, status_code, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [addInvoiceGenerationAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [updateOtherInvoiceGenerationAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateOtherInvoiceGenerationAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result = {}, status_code, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        success,
        fetching: false,
        statusCode: status_code,
      };
    },
    [updateOtherInvoiceGenerationAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addOtherInvoiceGenerationAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [addOtherInvoiceGenerationAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result = {}, status_code, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        success,
        fetching: false,
        statusCode: status_code,
      };
    },
    [addOtherInvoiceGenerationAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getAllOtherInvoicesListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllOtherInvoicesListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          statusCode: status_code,
          error: message,
          fetching: false,
        };
      }

      return {
        ...state,
        allOtherInvoicesList: result?.data,
        otherInvoicesTotal: result?.total_count,
        lockOthersEntriesDate: result?.lock_entry_date,
        fetching: false,
        statusCode: status_code,
      };
    },
    [getAllOtherInvoicesListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [getAllExpensesInvoicesListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllExpensesInvoicesListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        expensesInvoicesTotal: result?.total_count,
        allExpensesInvoicesList: result?.data,
        lockExpensesEntriesDate: result?.lock_entry_date,
      };
    },
    [getAllExpensesInvoicesListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [getAllRevenuInvoicesListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllRevenuInvoicesListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        revenueInvoicesTotal: result?.total_count,
        allRevenueInvoicesList: result?.data,
        lockRevenueEntriesDate: result?.lock_entry_date,
      };
    },
    [getAllRevenuInvoicesListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getSingleInvoiceDetailsAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleInvoiceDetailsAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, message, success, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleInvoiceDetails: result,
      };
    },
    [getSingleInvoiceDetailsAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [postInvoiceOcrAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postInvoiceOcrAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, message, success, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleInvoiceDetails: result,
      };
    },
    [postInvoiceOcrAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [updateInvoiceGenerationAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateInvoiceGenerationAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [updateInvoiceGenerationAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [copyInvoiceGenerationAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [copyInvoiceGenerationAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [copyInvoiceGenerationAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [deleteInvoiceAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteInvoiceAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [deleteInvoiceAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [deleteOtherInvoiceAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteOtherInvoiceAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [deleteOtherInvoiceAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [getSingleOtherInvoiceDetailsAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleOtherInvoiceDetailsAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result, status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleOtherInvoiceDetails: result?.[0],
      };
    },
    [getSingleOtherInvoiceDetailsAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [invoiceGenerationBulkUploadAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [invoiceGenerationBulkUploadAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, message, status_code, data = {} } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bulkUploadData: data,
      };
    },
    [invoiceGenerationBulkUploadAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),

    [invoiceGenerationSuspenseBulkUploadAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [invoiceGenerationSuspenseBulkUploadAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, message, status_code, data = {} } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bulkUploadData: data,
      };
    },
    [invoiceGenerationSuspenseBulkUploadAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),

    [invoiceGenerationRevenuesBulkUploadAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [invoiceGenerationRevenuesBulkUploadAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, message, status_code, data = {} } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bulkUploadData: data,
      };
    },
    [invoiceGenerationRevenuesBulkUploadAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [invoiceGenerationExpensesBulkUploadAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [invoiceGenerationExpensesBulkUploadAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { success, message, status_code, data = {} } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bulkUploadData: data,
      };
    },
    [invoiceGenerationExpensesBulkUploadAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [checkDuplicateEntryAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [checkDuplicateEntryAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, is_duplicate_invoice } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        isDuplicateEntry: is_duplicate_invoice,
      };
    },
    [checkDuplicateEntryAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [getInvoiceAllComment.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getInvoiceAllComment.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        allComments: result,
      };
    },
    [getInvoiceAllComment.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [getInvoiceCustomerInvoiceDownload.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      pdfFetching: true,
    }),
    [getInvoiceCustomerInvoiceDownload.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          pdfFetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        pdfFetching: false,
        statusCode: status_code,
        customerSingleInvoiceData: result,
      };
    },
    [getInvoiceCustomerInvoiceDownload.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      pdfFetching: false,
      error: error?.message,
    }),

    [postInvoiceAllComment.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postInvoiceAllComment.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        commentsSuccess: success,
      };
    },
    [postInvoiceAllComment.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [approveInvoiceAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [approveInvoiceAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        approvalSuccess: success,
      };
    },
    [approveInvoiceAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getPaymentPendingList.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getPaymentPendingList.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        paymentPendingList: result,
      };
    },
    [getPaymentPendingList.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getAllAllocationListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllAllocationListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        allAllocationList: result,
      };
    },
    [getAllAllocationListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [postLockingEntryAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postLockingEntryAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [postLockingEntryAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [invoiceNotesListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [invoiceNotesListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        // success,
        invoiceNotesList: result?.data,
        // message
      };
    },
    [invoiceNotesListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getEinvoiceDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getEinvoiceDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        eInvoiceData: result,
        message,
      };
    },
    [getEinvoiceDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getReviewEinvoiceDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getReviewEinvoiceDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        eInvoiceReviewData: result,
        message,
      };
    },
    [getReviewEinvoiceDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getBomDataAction.pending.toString()]: (state: InvoiceGenerationTypes) => ({
      ...state,
      fetching: true,
    }),
    [getBomDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bomListData: result,
        lockBOMEntriesDate: result?.lock_entry_date,
      };
    },
    [getBomDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getBOMSavedTemplateListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getBOMSavedTemplateListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bomSavedTemplateListData: result,
      };
    },
    [getBOMSavedTemplateListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [postBomDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postBomDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [postBomDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [updateBomDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateBomDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [updateBomDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [postEinvoiceDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postEinvoiceDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
          eInvoiceError: result?.data?.ErrorDetails,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [postEinvoiceDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [postCancelEinvoiceDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postCancelEinvoiceDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
          eInvoiceError: result?.data?.ErrorDetails,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [postCancelEinvoiceDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [postEinvoiceAuthenticationAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postEinvoiceAuthenticationAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [postEinvoiceAuthenticationAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [postEwayBillAuthenticationAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postEwayBillAuthenticationAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [postEwayBillAuthenticationAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [sendOverdueEmailApiAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [sendOverdueEmailApiAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          overDueEmailSuccess: success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        overDueEmailSuccess: success,
        overDueEmailMessage: message,
      };
    },
    [sendOverdueEmailApiAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getSingleBomDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleBomDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleBomData: result,
      };
    },
    [getSingleBomDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getSingleBomTemplateDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleBomTemplateDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleBomTemplateData: result,
      };
    },
    [getSingleBomTemplateDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getInvoiceHistoryDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      bulkUploadFetching: true,
    }),
    [getInvoiceHistoryDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          bulkUploadFetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        bulkUploadFetching: false,
        statusCode: status_code,
        invoiceHistoryData: result,
        invoiceHistoryCount: total_count,
      };
    },
    [getInvoiceHistoryDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getOthersInvoiceHistoryDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      bulkUploadFetching: true,
    }),
    [getOthersInvoiceHistoryDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          bulkUploadFetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        bulkUploadFetching: false,
        statusCode: status_code,
        othersHistoryData: result,
        othersHistoryCount: total_count,
      };
    },
    [getOthersInvoiceHistoryDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getBulkUploadHistoryAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getBulkUploadHistoryAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success, count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bulkUploadHistoryData: result,
        bulkUploadCount: count,
      };
    },
    [getBulkUploadHistoryAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [uniqueCheckBOMSavedTemplateNameAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      templateFetching: true,
    }),
    [uniqueCheckBOMSavedTemplateNameAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          templateFetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        templateFetching: false,
        statusCode: status_code,
        singleBomTemplateData: result,
        uniqueTemplateNameMessage: message,
      };
    },
    [uniqueCheckBOMSavedTemplateNameAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      templateFetching: false,
    }),

    ////review E-way bill
    [getReviewEWayBillDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getReviewEWayBillDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        eWayBillReviewData: result,
      };
    },
    [getReviewEWayBillDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    ///generate E-Way bill

    [getGenerateEWayBillAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getGenerateEWayBillAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
          eWayBillError: result?.data?.info
            ? result?.data?.info
            : result?.message,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        // eWayBillReviewData: result,
        success,
        message,
      };
    },
    [getGenerateEWayBillAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [cancelEWayBillDataAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [cancelEWayBillDataAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
          eWayBillError: result?.data?.info
            ? result?.data?.info
            : result?.message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [cancelEWayBillDataAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [postExtendEWayBillAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postExtendEWayBillAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
          eWayBillError: result?.data?.info
            ? result?.data?.info
            : result?.message,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        // eWayBillReviewData: result,
        success,
        message,
      };
    },
    [postExtendEWayBillAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    ////update E-Way bill

    [updateVehicleEWayBillDetails.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateVehicleEWayBillDetails.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
          eWayBillUpdateError: result?.data?.info
            ? result?.data?.info
            : result?.message,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        // eWayBillReviewData: result,
        success,
        message,
      };
    },
    [updateVehicleEWayBillDetails.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [updateTransporterEWayBillDetails.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateTransporterEWayBillDetails.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success,
          eWayBillUpdateError: result?.data?.info
            ? result?.data?.info
            : result?.message,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        // eWayBillReviewData: result,
        success,
        message,
      };
    },
    [updateTransporterEWayBillDetails.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    ////
    [checkDistanceCountAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      pinCodeFetching: true,
    }),
    [checkDistanceCountAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { data } = payload;
      if (data?.success === 0) {
        return {
          ...state,
          pinCodeFetching: false,
          statusCode: data?.status_code,
          // // error: message,
          // success:0,
          pinCodeDistanceCountData: data?.result,
          pinCodeError: data?.result?.message,
        };
      }
      return {
        ...state,
        pinCodeFetching: false,
        statusCode: data?.status_code,
        // eWayBillReviewData: result,
        pinCodeDistanceCountData: data?.result,
        success: data?.success,
        message: data?.result?.message,
      };
    },

    [checkDistanceCountAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => {
      return {
        ...state,
        pinCodeFetching: false,
        pinCodeError: error?.message,
        success: 0,
      };
    },
    // lock bom
    [postLockingEntryBOMAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postLockingEntryBOMAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [postLockingEntryBOMAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    // column assined
    [getClientColumnAssignedListAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientColumnAssignedListAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { result = [], message, status_code, success } = payload;
      const { expenses, revenues, others } = result;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          isClientColumnAssignedSuccess: success,
          statusCode: status_code,
          isClientColumnAssignedMessage: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        // mappedExpensesColumnsList: expenses,
        // mappedRevenueColumnsList: revenues,
        // mappedOthersColumnList: others,
        isClientColumnAssignedMessage: message,
      };
    },
    [getClientColumnAssignedListAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      isClientColumnAssignedMessage: error?.message,
      isClientColumnAssignedSuccess: 0,
      fetching: false,
    }),
    [getGstrTwoATwoBComparePayloadAction.pending.toString()]: (
      state: InvoiceGenerationTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getGstrTwoATwoBComparePayloadAction.fulfilled.toString()]: (
      state: InvoiceGenerationTypes,
      { payload }
    ) => {
      const { status_code, message, success, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        singleInvoiceDetails: result,
      };
    },
    [getGstrTwoATwoBComparePayloadAction.rejected.toString()]: (
      state: InvoiceGenerationTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
  },
});

export const {
  resetInvoiceGenerationError,
  resetInvoiceGenerationFetching,
  resetInvoiceGenerationSuccess,
  resetMappedExpensesColumnList,
  resetMappedOtherColumnList,
  resetMappedRevenueColumnList,
  resetGetAllOtherInvoicesList,
  resetExpenseInvoicesList,
  resetRevenueInvoicesList,
  resetSingleInvoiceDetails,
  resetSingleOtherInvoiceDetails,
  resetUpdateInvoiceGenerationSuccess,
  resetUpdateInvoiceGenerationError,
  resetError: resetInvoicingError,
  resetSuccess: resetInvoicingSuccess,
  resetStatusCode: resetInvoiceStatusCode,
  resetInvoicingFetching,
  resetBulkUploadData,
  resetDuplicateEntry,
  resetApprovalSuccess,
  resetcommentsSuccess,
  resetExpenseInvoicesTotal,
  resetRevenueInvoicesTotal,
  resetOtherInvoicesTotal,
  resetSuccess,
  resetAllocationList,
  resetAllAllocationList,
  resetEinvoiceReviewData,
  resetEinvoiceData,
  resetEinvoiceError,
  resetEWayBillError,
  resetInvoiceNotesList,
  resetInvoiceGenerationOverDueEmailSuccess,
  resetSingleInvoiceData,
  resetBomDataList,
  resetSingleBomData,
  resetInvoiceGenerationOverDueEmailMessage,
  resetSingleBomTemplateData,
  resetBomSavedTemplateListData,
  resetUniqueTemplateNameMessage,
  resetInvoiceHistoryData,
  resetBulkUploadHistoryData,
  resetBulkUploadHistoryCount,
  resetOthersHistoryData,
  resetOthersHistoryCount,
  resetEWayBillReviewData,
  resetPinCodeError,
  resetPinCodeDistanceCountData,
  resetLockBomEntriesDate,
  resetEWayBillUpdateError,
  resetIsClientColumnAssignedSuccess,
  resetIsClientColumnAssignedMessage,
} = invoiceGenerationSlice.actions;
